import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { Boxes, Zap, DollarSign, Layers, Award, Globe } from 'lucide-react';

const iconMap = {
  1: Boxes,      // Modelo modular
  2: Zap,        // Sistema de conexión inmediata
  3: DollarSign, // Costos optimizados
  4: Layers,     // Infraestructura + IA + Software
  5: Award,      // Diseño robusto
  6: Globe       // Escalabilidad global
};

const CompetitiveAdvantages = () => {
  const { content } = useLanguage();
  const { competitiveAdvantages, ui } = content;

  return (
    <section className="py-20 lg:py-32 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            {ui.competitiveAdvantages.title}
          </h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto">
            {ui.competitiveAdvantages.subtitle}
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {competitiveAdvantages.map((advantage) => {
            const Icon = iconMap[advantage.id];
            return (
              <div
                key={advantage.id}
                className="group relative bg-gradient-to-b from-gray-900 to-gray-950 border border-gray-800 rounded-2xl p-8 hover:border-blue-600/50 transition-all duration-300"
              >
                {/* Icon */}
                <div className="w-14 h-14 bg-blue-600/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600/20 transition-colors duration-300">
                  <Icon className="text-blue-400" size={28} />
                </div>
                
                {/* Content */}
                <h3 className="text-xl font-semibold text-white mb-3">
                  {advantage.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {advantage.description}
                </p>

                {/* Hover effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-600/5 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
              </div>
            );
          })}
        </div>

        {/* Bottom highlight */}
        <div className="mt-16 p-10 bg-gradient-to-r from-blue-950/30 to-gray-950/30 border border-blue-900/30 rounded-3xl text-center">
          <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
            {ui.competitiveAdvantages.bottomTitle}
          </h3>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto">
            {ui.competitiveAdvantages.bottomText}
          </p>
        </div>
      </div>
    </section>
  );
};

export default CompetitiveAdvantages;
